var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendPlane({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.68328 10.7191L10.5468 6.91971C10.6384 6.88068 10.7165 6.81557 10.7714 6.73248C10.8264 6.6494 10.8556 6.552 10.8556 6.45241C10.8556 6.35281 10.8264 6.25542 10.7714 6.17233C10.7165 6.08925 10.6384 6.02414 10.5468 5.98511L1.68328 2.18574C1.60653 2.15226 1.52266 2.13842 1.43922 2.14546C1.35578 2.1525 1.27541 2.1802 1.20536 2.22607C1.13531 2.27193 1.07777 2.33451 1.03795 2.40817C0.998124 2.48182 0.977263 2.56423 0.977247 2.64796L0.972168 4.98955C0.972168 5.24352 1.1601 5.46193 1.41407 5.49241L8.59122 6.45241L1.41407 7.40733C1.1601 7.44288 0.972168 7.6613 0.972168 7.91527L0.977247 10.2569C0.977247 10.6175 1.34804 10.8664 1.68328 10.7191Z",
    fill: "#573B76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.6667,
    height: 12.1905,
    fill: "white",
    transform: "translate(0.464355 0.35714)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendPlane);
export default __webpack_public_path__ + "static/media/sendPlane.9ecaf070a8f2a0e1ab4c674a9d860858.svg";
export { ForwardRef as ReactComponent };